// @ts-nocheck
import AuthorPreview from "components/User/AuthorPreview/AuthorPreview";
import { t } from "i18next";
import React from "react";
import { useQuery } from "react-query";
import "./UsersList.css";
import { AsyncUserCard } from "components/User/Card/UserCard";
import { useNavigate } from "react-router-dom";

export function AsyncUsersList(props) {
	const { queryKey, queryFn } = props;
	const { isLoading, data } = useQuery(queryKey, queryFn, { retry: false });

	const getItems = (data) => {
		if (!data) return [];
		if (Array.isArray(data)) return data;
		if (data.items && Array.isArray(data.items)) return data.items;
		return [];
	};

	if (isLoading) {
		return <div className="userlist-placeholder">{t("Groups.LOADING_USERS")}</div>;
	}

	let items = getItems(data).map((e) => ({ ...e, employeeId: e.employeeId ?? e.id }));

	if (items.length === 0) {
		return props.hideIfNoData ? null : (
			<div className="userlist-placeholder">{t("Groups.NO_USERS")}</div>
		);
	}

	if (props.treat) {
		items = items.map(props.treat);
	}

	if (props.sort) {
		items = items.sort(props.sort);
	} else {
		items = items.sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
	}

	return (
		<UsersList users={items} {...props} />
	);
}

function UsersList(props) {
	const { users, max, width, className, total, fullView } = props;
	const row_ref = React.createRef();
	const navigate = useNavigate();


	if (!users?.length)
		return (props.hideIfNoData ? false : <div>{t("Groups.NO_USERS")}</div>);

	function handleScroll(e) {
		e.stopPropagation();
		if (row_ref?.current)
			row_ref.current.scrollLeft = row_ref.current.scrollLeft + e.deltaY;
	}

	function genList() {
		if (!users || users.length === 0) {
			console.warn("⚠️ No users to display");
			return [];
		}

		const limitedUsers = max ? users.slice(0, max) : users;

		return limitedUsers.map((user) => {
			const key = user.employeeId;

			const goToContact = (e) => {
				const employeeId = user.employeeId
				navigate("/contacts/?employeeId=" + employeeId);
			};

			return (
				<div key={key} onClick={goToContact}>
					{fullView ? (
						<AsyncUserCard employeeId={user.employeeId} />
					) : (
						<AuthorPreview
							companyId={user.companyId}
							employeeId={user.employeeId}
							title={
								(user.employeFirstName ?? user.firstName ?? "") + " " +
								(user.employeLastName ?? user.lastName ?? "").toUpperCase()
							}
							imgWidth={width}
							imgRes={"urlMin"}
						/>
					)}
				</div>
			);
		});
	}

	return (
		<div className={"UsersList" + (className ? " " + className : "")}>

			<div className="list gap-2" ref={row_ref} onWheel={handleScroll}>
				{genList()}
			</div>
			<div className="more-users">
				{
					(users.length > max || total) &&
					<div>
						<div
							title={users.slice(max, users.length).map(a => (a.lastName + " " + a.firstName)).join("\n")}
							className="more">{!total ? (users.length - max) + "+" : users.length}
						</div>
					</div>
				}
			</div>
		</div>
	);
}

export default UsersList;
